import { useState } from "react";

export default function MgmtCard({ person }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      className="rounded-[14px] px-[22px] py-[26px] flex flex-col items-center text-center gap-3 cursor-pointer transition-all [transition-duration:280ms]"
      style={{
        background: hov ? person.color : "#ffffff",
        border: `1.5px solid ${hov ? person.color : "#e2ddd6"}`,
        boxShadow: hov
          ? `0 10px 30px ${person.color}33`
          : "0 2px 10px rgba(0,0,0,0.05)",
      }}
    >
      <div
        className="w-[76px] h-[76px] rounded-full flex items-center justify-center font-serif text-2xl font-bold transition-all [transition-duration:280ms]"
        style={{
          background: hov ? "rgba(255,255,255,0.18)" : person.color + "18",
          border: `2.5px solid ${hov ? "rgba(255,255,255,0.45)" : person.color + "50"}`,
          color: hov ? "#fff" : person.color,
        }}
      >
        {person.initials}
      </div>
      <div>
        <div
          className="text-[10px] font-bold tracking-[0.1em] uppercase mb-[5px] transition-colors [transition-duration:280ms]"
          style={{ color: hov ? "rgba(255,255,255,0.65)" : person.color }}
        >
          {person.role}
        </div>
        <div
          className="font-serif text-lg font-bold mb-1 transition-colors [transition-duration:280ms]"
          style={{ color: hov ? "#fff" : "#003d2b" }}
        >
          {person.name}
        </div>
        <div
          className="text-xs leading-[1.5] transition-colors [transition-duration:280ms]"
          style={{ color: hov ? "rgba(255,255,255,0.65)" : "#5c5c5c" }}
        >
          {person.extra}
        </div>
      </div>
    </div>
  );
}
